export enum EmployeesReportSchemasWorkingMode {
  NORMAL_STATE = 0,
  REMOVE_STATE = 1,
  SHARE_STATE = 2,
}
